module.exports = __webpack_public_path__ + "img/land-mine.ba642c5a.svg";